const GARAGE_ACTION_TYPES = Object.freeze({
  FETCH_DATA_GARAGES: 'FETCH_DATA_GARAGES',
  SEARCH_GARAGES: 'SEARCH_GARAGES',
  FETCH_DATA_TIRECODES: 'FETCH_DATA_TIRECODES',
});

export default GARAGE_ACTION_TYPES;
